import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ToasterConfig, BodyOutputType} from 'angular2-toaster/angular2-toaster';
@Component({
  selector: 'dcu-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['../../scss/vendors/toastr/toastr.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationComponent implements OnInit {

  toasterconfig: ToasterConfig =
    new ToasterConfig({
      timeout: 5000,
      showCloseButton: true,
      tapToDismiss: false,
      bodyOutputType: BodyOutputType.TrustedHtml
    });

  constructor() { }

  ngOnInit(): void {
  }

}
